import React from "react";
import classnames from "classnames";
import CheckIcon from "../icons/Check";

import "./List.scss";

var iconMap = new Map();
iconMap.set("check", <CheckIcon />);

/* Default list style don’t use a custom icon */
iconMap.set("bullet", null);
iconMap.set("number", null);

const List = ({children, icon}) => {
  return (
    <ul className={classnames("List", icon ? "ListWithCustomIcon" : "")}>
      {children}
    </ul>
  );
}

const ListItem = ({children, icon}) => { 
  return (
    <li>
      {icon && iconMap.get(icon)}
      {children}
    </li>
  )
}

export default Object.assign(List, {
  ListItem: ListItem,
});
